import { Button } from "@chakra-ui/react";
import type { FormSubmitButtonProps } from "./FormSubmitButton.d";

const FormSubmitButton = ({ isLoading = false, isDisabled = false, text, ...props }: FormSubmitButtonProps) => (
  <Button
    isLoading={isLoading}
    type="submit"
    w="full"
    minW="min-content"
    isDisabled={isDisabled}
    borderRadius="sm"
    {...props}
  >
    {text}
  </Button>
);

export default FormSubmitButton;
